import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAuthModal } from '../contexts/AuthModalContext';
import { Button } from '../components';
import PublicHeader from '../components/PublicHeader';
import StaticFooter from '../components/StaticFooter';

// Landing page for unauthenticated users
function LandingPage() {
  const navigate = useNavigate();
  const { openLoginModal } = useAuthModal();

  return (
    <div className="min-h-screen bg-oro-bg text-text-primary flex flex-col">
      {/* Header */}
      <PublicHeader />

      {/* Main content */}
      <main className="flex-1 px-4 py-6">
        {/* Hero Section */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-text-primary mb-3 leading-tight">
            Welcome to ORO MOVE<sup>™</sup>
          </h1>
          <p className="text-text-secondary text-base">
            Tools for communities that move together.
          </p>
        </div>

        {/* Hero Card with Photo */}
        <div className="mb-4">
          <div className="relative rounded-xl overflow-hidden bg-oro-surface border border-oro-border mx-auto w-[80%] sm:w-full">
            <div 
              className="h-[416px] sm:h-[520px] bg-cover bg-center"
              style={{
                backgroundImage: "url('https://images.unsplash.com/photo-1762709753410-25f211f9402f?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')"
              }}
            >
            </div>
          </div>
        </div>

        {/* Invite Only Message */}
        <div className="text-center mb-6">
          <p className="text-lg text-text-primary font-medium mb-2">
            Currently invite-only
          </p>
          <p className="text-text-secondary">
            We can't wait to have you join the movement.
          </p>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-xs mx-auto">
            <Button
              variant="primary"
              size="lg"
              className="flex-1 py-3"
              onClick={() => openLoginModal()}
            >
              Sign In
            </Button>
            <Button
              variant="secondary"
              size="lg"
              className="flex-1 py-3"
              onClick={() => navigate('/waitlist')}
            >
              Join Waitlist
            </Button>
          </div>
        </div>
      </main>

      {/* Fixed Footer */}
      <StaticFooter />
    </div>
  );
}

export default function HomePage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  // Redirect authenticated users to the home page (main dashboard)
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/home');
    }
  }, [authLoading, isAuthenticated, navigate]);

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div className="min-h-screen bg-oro-bg flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin mx-auto mb-2"></div>
          <p className="text-sm text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  // Show landing page for unauthenticated users
  return <LandingPage />;
}
